import useFirebaseActionsHandler from "core/features/auth/firebase-actions/useFirebaseActionsHandler";

function FirebaseActions() {
  useFirebaseActionsHandler();
  return null;
}

export default FirebaseActions;
